import A from "./a";

export default {
    A
};